import type { TitleSize } from '@/ui/text/title/Title'
import { z } from 'zod'

export const loyaltyCardTagSize = ['md', 'lg', 'xl', '3xl'] as const satisfies readonly [
  TitleSize,
  ...TitleSize[],
]

export const loyaltyCardTagSizeSchema = z.enum(loyaltyCardTagSize)
export type LoyaltyCardTagSize = (typeof loyaltyCardTagSize)[number]
